/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespLocationsModule_viewer$ref = any;
export type HpRespLocationsModule_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urlLabel: string | null;
            readonly weight: number | null;
            readonly locationPageExists: boolean | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": HpRespLocationsModule_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HpRespLocationsModule_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isClient",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "regionalInfo",
                    "storageKey": "regionalInfo(regionTypes:\"ITEM_LOCATION\")",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "regionTypes",
                            "value": "ITEM_LOCATION"
                        }
                    ],
                    "concreteType": "RegionalInfo",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "regionsByZipCode",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RegionsByZipCode",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "displayName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urlLabel",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "weight",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "locationPageExists",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ba9a9208d087b817abad41809ece2741';
export default node;
